import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Button, DataNotFound, DatePicker, Dialog, Dropdown, GenericTable, Input, Loader, Switcher, tCell } from "../utils";
import { useDebounce, useGraphTimelineData, useTelemetryData } from "../../services/hooks";
import { buttonClasses } from "../utils/theme";
import DateRangePicker from "../utils/GenericDateRangeFilter/GenericDateRangeFilter";
import DeviceTimelineGraph from "../Dashboard/Test";

const HEARTBEAT = "HEARTBEAT";
const JB_OPEN = "JbOpen";
const BOOM_OPEN = "BoomOpen";
const TAG_SCAN = "TAG-SCAN";
const VEHICLE_CAPTURE = "VEHICLE-CAPTURE";

const ViewTelemetry = ({ open, onClose, title, deviceData }) => {
	let _defaultFilter = {
		type: "HEARTBEAT",
		page: 1,
		limit: 100,
		deviceId: deviceData?.imei,
		plantId: deviceData?.plantId,
		startTime: dayjs().subtract(1, "hour").toDate(),
		endTime: new Date(),
	};

	let graohDefaultFilter = {
		plantId: deviceData?.plantId,
		deviceId: deviceData?.imei,
	}
	const [filters, setFilters] = useState(_defaultFilter);
	const { page, limit } = filters;
	const [isGraph, setIsGraph] = useState(false);
	const [graphFilter, setGraphFilter] = useState({
		startDay: dayjs().subtract(7, "day"),
		endDay: dayjs().subtract(1, "day"),
	});


	const { telemetryData, isLoading, count, getTelemetryData } = useTelemetryData({
		..._defaultFilter,
		startTime: _defaultFilter.startTime.toISOString(),
		endTime: _defaultFilter.endTime.toISOString(),
	});
	const { graphTimelineData, isLoading: isGraphTImeLineLoading,  getGraphTimelineData } = useGraphTimelineData({...graohDefaultFilter, ...graphFilter})
	let typeOpts = [{ label: "HEARTBEAT ", value: HEARTBEAT }];
	if (deviceData.deviceType == "rfidReader") {
		typeOpts.push({ label: "JbOpen", value: JB_OPEN }, { label: "BoomOpen", value: BOOM_OPEN }, { label: "Tag Scan", value: TAG_SCAN });
	} else if (deviceData.deviceType == "camera") {
		typeOpts.push({ label: "Vehicle Capture", value: VEHICLE_CAPTURE });
	}

	const typeValue = typeOpts.find((_) => _.value == filters?.type) || null;

	let header = ["S.no", "Packet Time", "Type"];
	if (typeValue?.value == TAG_SCAN) {
		header.push("Antenna ID", "TID", "VMS Response");
	} else if (typeValue?.value == VEHICLE_CAPTURE) {
		header.push("Vehicle No", "VMS Response");
	}

	const rows = telemetryData?.map((d, i) => {
		let row = [];
		row.push(tCell((page - 1) * limit + i + 1), tCell(dayjs(d?.timestamp).format("DD MMM YYYY, hh:mm:ss A")), tCell(d?.type));
		if (typeValue?.value == TAG_SCAN) {
			row.push(tCell(d.antennaId), tCell(d.tId), tCell(d.vmsResponse));
		} else if (typeValue?.value == VEHICLE_CAPTURE) {
			row.push(tCell(d.vehicleNumber), tCell(d.vmsResponse));
		}
		return row;
	});

	const onPageChange = (page) => {
		setFilters((o) => ({ ...o, page: page + 1 }));
		getTelemetryData({ ...filters, page: page + 1, startTime: filters.startTime.toISOString(), endTime: filters.endTime.toISOString() });
	};
	const onPageSizeChange = (e) => {
		setFilters((o) => ({ ...o, limit: e.target.value }));
		getTelemetryData({ ...filters, limit: e.target.value, startTime: filters.startTime.toISOString(), endTime: filters.endTime.toISOString() });
	};

	const debouncedRequest = useDebounce(() => {
		getTelemetryData({ ...filters, startTime: filters.startTime.toISOString(), endTime: filters.endTime.toISOString() });
	});

	const handleFilterChange = (e) => {
		let { name, value } = e.target;

		setFilters((old) => ({ ...old, [name]: value }));
		if (name == "tId" && value != "" && value.length < 24) return;
		debouncedRequest();
	};
	const handleResetFilters = () => {
		setFilters(_defaultFilter);
		getTelemetryData({ ..._defaultFilter, startTime: _defaultFilter.startTime.toISOString(), endTime: _defaultFilter.endTime.toISOString() });
	};

	const handleDateRangeSelect = (range) => {
		if (range) {
			let _start = new Date(range.startDate);
			let _end = new Date(range.endDate);
			setFilters((old) => ({ ...old, startTime: _start, endTime: _end }));

			getTelemetryData({ ...filters, startTime: _start.toISOString(), endTime: _end.toISOString() });
		}
	};
	useEffect(() => {
		if (isGraph) {
			fetchGraphData();
		}
	}, [graphFilter.startDay, graphFilter.endDay]);
	const handleGraphFilterChange = (e) => {
		const { name, value } = e.target;
		setGraphFilter((prev) => ({
			...prev,
			[name]: value
		}));
	};

	const handleGraphResetFilters = () => {
		setGraphFilter({
			startDay: dayjs().subtract(7, "day"),
			endDay: dayjs().subtract(1, "day"),
		});
	};
	const fetchGraphData = async () => {
			const payload = {
				plantId: deviceData?.plantId,
				deviceId: deviceData?.imei,
				startDay: dayjs(graphFilter.startDay).format("YYYY-MM-DD"),
				endDay: dayjs(graphFilter.endDay).format("YYYY-MM-DD"),
			};
			await getGraphTimelineData(payload);
	};
	return (
		<Dialog size="xl" open={open} handleClose={onClose} noBtn minHeight={isGraph ? "auto" : "80vh"} 
			title={
				<div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "90%" }}>
					<span>{title}</span>

					{/* Switcher goes here */}
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<span>Packets</span>

						<Switcher
						name="viewToggle"
						checked={isGraph}
						onChange={(e) =>{ setIsGraph(e.target.checked)}}
						size="small"
						/>

						<span>Timeline</span>
					</div>
				</div>
			}
			>
			{isGraph?
			<>
				<div style={{ display: "flex", flexWrap: "wrap", marginBottom: "5px" }}>
					<div style={{ maxWidth: "180px", minWidth: "180px"}}>
						<DatePicker
							label="Start Date"
							name="startDay"
							value={graphFilter.startDay}
							maxDATE={dayjs().subtract(1, "day")}
							onChange={(value) => handleGraphFilterChange({ target: { name: "startDay", value } })}
							isRequired
						/>
					</div>
					<div style={{ maxWidth: "180px", minWidth: "180px", margin: "0px 5px" }}>
						<DatePicker
							label="End Date"
							name="endDay"
							value={graphFilter.endDay}
							maxDATE={dayjs().subtract(1, "day")}
							onChange={(value) => handleGraphFilterChange({ target: { name: "endDay", value } })}
							isRequired
						/>
					</div>
					<div style={{ minWidth: "180px", display: "flex", gap: "0.5rem", maxHeight: "37px" }}>
						<Button text="Clear" onClick={handleGraphResetFilters} style={buttonClasses.lynkitOrangeEmpty} />
					</div>
				</div>
				{isGraphTImeLineLoading ? (
					<div style={{ textAlign: "center", padding: "40px" }}>
						<Loader/>
					</div>
					) : !graphTimelineData?.length ||
					!graphTimelineData[0]?.records?.length ? (
					<div style={{ textAlign: "center", padding: "40px" }}>
						<DataNotFound/>
					</div>
					) : (
					<div
						className="vehicleMovementContainer"
						style={{
						borderRadius: "8px",
						padding: "0px 15px",
						boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
						}}
					>
						<div className="vehicleMovementHeading">
						Vehicle Movement
						</div>

						<DeviceTimelineGraph data={graphTimelineData[0]?.records} />
					</div>
					)}
				</>
			:
			<>
			<div style={{ display: "flex", flexWrap: "wrap", marginBottom: "5px" }}>
				<div style={{ maxWidth: "275px", minWidth: "265px", marginTop: "7px" }}>
					<DateRangePicker onDateRangeSelect={handleDateRangeSelect} initialStartDate={filters.startTime} initialEndDate={filters.endTime} isHourTime={true} />
				</div>
				<div style={{ maxWidth: "180px", minWidth: "180px", margin: "0px 5px" }}>
					<Dropdown id="type" name="type" label="Type" onChange={(op) => handleFilterChange({ target: { value: op?.value || "", name: "type" } })} options={typeOpts} value={typeValue} />
				</div>
				{typeValue?.value == TAG_SCAN ? (
					<div style={{ maxWidth: "180px", minWidth: "180px", margin: "0px 5px" }}>
						<Input id="tId" name="tId" label="TID" onChange={handleFilterChange} value={filters.tId} />
					</div>
				) : typeValue?.value == VEHICLE_CAPTURE ? (
					<div style={{ maxWidth: "180px", minWidth: "180px", margin: "0px 5px" }}>
						<Input id="vNo" name="vehicleNumber" label="Vehicle No" onChange={handleFilterChange} value={filters.vehicleNumber} />
					</div>
				) : null}

				<div style={{ minWidth: "180px", display: "flex", gap: "0.5rem", maxHeight: "37px" }}>
					<Button text="Clear" onClick={handleResetFilters} style={buttonClasses.lynkitOrangeEmpty} />
				</div>
			</div>

			<GenericTable header={header} rows={rows} pageCount={count} pageNo={page} limit={limit} onPageChange={onPageChange} onPageSizeChange={onPageSizeChange} isLoading={isLoading} />
		</>
		}		
		</Dialog>
	);
};

export default ViewTelemetry;
